/* 
 * 
 * 
 * 
 * 								L I B   N A M E S
 * 
 * 
 * 
 */

export const lib_names = {
	aspectRatios: {
		catalog_item: { 'ar': 1 / 1, 'w': 1, 'h': 1 },
		event_poster: { 'ar': 1 / 1.414, 'w': 1, 'h': 1.414 },
		poi: { 'ar': 11 / 16, 'w': 11, 'h': 16 },
		tales: { 'ar': 9 / 16, 'w': 9, 'h': 16 },
		user___cover: { 'ar': 16 / 9, 'w': 16, 'h': 9 },
		user___profile: { 'ar': 1 / 1, 'w': 1, 'h': 1 },
	},
	localStorage: {
		user___cookies_accepted: '7e9381a3d73bae265235aa3068c3f2604ecacd3e',
		user___language: '9d9276431fa569a2d17f51a9a797191ac60cede4',
		user___location: 'fa25fa1a1acecb305decb0262f56ca9a3b852e20',
	},
	lodash: {
		debounce_delay: 500,
	},
	MapBoxGL: {
		accessToken: 'pk.eyJ1Ijoicmlrb3p6IiwiYSI6ImNsazAzeTVzZjBnZ2ozZG1sOXNkbmdpMHMifQ.YEm8hzqY7Q0WBewrRtl6ig',
		accessToken_geocoding: 'pk.eyJ1Ijoicmlrb3p6IiwiYSI6ImNsazAzeTVzZjBnZ2ozZG1sOXNkbmdpMHMifQ.YEm8hzqY7Q0WBewrRtl6ig',
		attributionControl: false,
		markers___limit: 5000,
		doubleClickZoom: false,
		dragRotate: false,
		markerColor: '#FD4755',
		mapbox_fly_options: {
			speed: 2,
			curve: 1,
			essential: true
		},
		maxPitch: 0,
		maxZoom: 20,
		minZoom: 11.5,
		minZoomToDiscover: 7.5,
		style_normal: 'mapbox://styles/rikozz/clk0414x700a201pfdf0z70gh',
		touchPitch: false,
		zoom: 11.5,
		zoomPreview: 15.5,
	},
	mongo: {
		query_limit: 15,
		query_limit_extended: 500,
		query_limit_few: 3,
		query_limit_single: 1,
	},
	share_urls: {
		events: '/view/event',
		poi: '/view/poi'
	}
}